<template>
  <div class="collectionCardDoc">
    <documentation-container :title="title">
      <template slot="content">
        <div class="menuexpansionDoc">
          <adx-discussions :list="lists" @submitComment="submit" @goToBast="bast" @goToMockup="mockup"/>
        </div>
      </template>
    </documentation-container>
  </div>
</template>

<script>
import Discussions from '@/components/Discussions'
import DocumentationContainer from '@/components/DocumentationContainer'
import Input from '@/components/Form/Input'
import TextArea from '@/components/Form/TextArea'
import Dropdown from '@/components/Form/SelectDropdown'
import LoadingSpinner from '@/components/Loading/Secondary-white'

export default {
  name: 'adx-discussions-slot',
  components: {
    'adx-discussions': Discussions,
    'documentation-container': DocumentationContainer,
    'adx-dropdown': Dropdown,
  },
  data(){
    return {
      title: "Discussion",
      input: null,
      inputye: [],
      lists: [ 
        {
          'id': 0,
          'label': 'You',
          'comment': 'hehehehehehehehehheehhehehehehehehhehehehehhehehehehehehehehehe hehehehehehehehehheehhehehehehehehhehehehehhehehehehehehehehehehehehehehehehehehheehhehehehehehehhehehehehhehehehehehehehehehe hehehehehehehehehheehhehehehehehehhehehehehhehehehehehehehehehe hehehehehehehehehheehhehehehehehehhehehehehhehehehehehehehehehe',
          'date':this.today1()
        },
        {
          'id': 1,
          'label': 'Bast Uploaded',
          'comment' : '3 pics',
          'date' : this.today(),

          'replies': [
              {
                'id' : 1,
                'label' : 'label child 1',
                'comment' : 'yoooo',
                'date' : this.today1()
              },
              {
                'id' : 2,
                'label' : 'label child 2',
                'comment' : 'replies number 2',
                'date' : this.today2()
              },
              {
                'id' : 3,
                'label' : 'label child 3',
                'comment' : 'replies number 3',
                'date' : this.today3()
              }
          ],
          'bast' : [
              {
                'id' :1,
                'img': '/img/collection/cafe&restaurant.jpg'
              },
              {
                'id' :2,
                'img': '/img/collection/airport_lounge.jpg'
              },
              {
                'id' :3,
                'img': '/img/collection/office_building.jpg'
              },
              {
                'id' :4,
                'img': '/img/collection/cafe&restaurant.jpg'
              }
            ],
          'mockup':[

          ]
        },
        {
          'id': 2,
          'label': 'Mockup Uploaded',
          'comment' : '2 pics',
          'date' : this.today(),

          'replies': [
              {
                'id' : 1,
                'label' : 'Ana',
                'comment' : 'need some revisions',
                'date' : this.today1()
              },
              {
                'id' : 2,
                'label' : 'Ani',
                'comment' : 'why?',
                'date' : this.today2()
              },
              {
                'id' : 3,
                'label' : 'Ana',
                'comment' : 'why not?',
                'date' : this.today3()
              }
          ],
          'bast' : [
            ],
          'mockup':[
            {
                'id' :1,
                'img': '/img/collection/cafe&restaurant.jpg'
              },
              {
                'id' :2,
                'img': '/img/collection/airport_lounge.jpg'
              },
          ]
        },
        
      ],
    }
  },
  methods: {
    today() {
      let today = new Date();
      today.setDate(today.getDate() - 8)
      return today
    },
    today1() {
      let today = new Date();
      today.setDate(today.getDate())
      return today
    },
    today2() {
      let today = new Date();
      today.setDate(today.getDate() - 1)
      return today
    },
    today3() {
      let today = new Date();
      today.setDate(today.getDate() + 1)
      return today
    },
    submit(comment, item){
      this.$notify({
        group: 'saved',
        title: 'submit',
        text: 'comment "'+ comment+'" for id '+ item.id +' has submitted',
        type: 'success'
        });
    },
    bast(){
      this.$notify({
        group: 'saved',
        title: 'event',
        text: 'event goToBast',
        type: 'success'
        });
    },
    mockup(){
      this.$notify({
        group: 'saved',
        title: 'event',
        text: 'event goToMockup',
        type: 'success'
        });
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>